import React, { useEffect, useCallback, useState } from 'react';
import { compose } from 'ramda';
import { componentService } from '@core/js/services/component.service';
import { SHUFTI } from './constants';
import { withPortlet } from '@core/js/components/system/Portlet';
import { dispatcher } from '@core/js/backbone/dispatcher';
import { ShuftiConfig } from './types';
import ShuftiContent from './ShuftiContent';

const ShuftiBare: React.FC<ShuftiConfig> = (config) => {
    const [verificationUrl, setVerificationUrl] = useState('');

    const handleIframeClose = useCallback(() => {
        setVerificationUrl('');
    }, [setVerificationUrl]);

    useEffect(() => {
        dispatcher.listen('shufti:iframe:close', handleIframeClose);

        return () => {
            dispatcher.removeListener('shufti:iframe:close', handleIframeClose);
        };
    }, [handleIframeClose]);

    return verificationUrl ? (
        <iframe title="shuftiIframe" src={verificationUrl} allow="geolocation;microphone;camera;midi;encrypted-media" />
    ) : (
        <ShuftiContent setVerificationUrl={setVerificationUrl} config={config} />
    );
};

export const Shufti = compose(withPortlet())(ShuftiBare);

componentService.registerPageComponents({ [SHUFTI]: Shufti });
componentService.registerWebContentComponents({ [SHUFTI]: Shufti });
